module.exports = __webpack_public_path__ + "static/media/booking.d4a64ac0.png";